import { $rtkApi } from 'shared/api/rtkApi';
import { ResponseData } from 'shared/types';
import { mapCountryFromDto } from '../../lib/mapCountry';
import { Country, CountryDto } from '../types/countrySchema';

export const countryApi = $rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.query<Country[], void>({
      query: () => ({
        url: `/countries`,
        method: 'GET',
      }),
      transformResponse: (response: ResponseData<CountryDto[]>) =>
        response.data.map((data) => mapCountryFromDto(data)),
    }),
  }),
});

export const { useGetCountriesQuery } = countryApi;
